import React from 'react'

export function TimeToRead({ minutes }) {
  return <>{minutes} min read</>
}
